var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 27,
    viewBox: "0 0 43 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5444 2.7998H16.0883V23.3819H27.5444V2.7998Z",
    fill: "#FF5A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8509 13.0915C16.8509 8.90985 18.8168 5.19847 21.8333 2.80048C19.6133 1.05495 16.8128 0 13.7581 0C6.52179 0 0.666626 5.85516 0.666626 13.0915C0.666626 20.3278 6.52179 26.183 13.7581 26.183C16.8128 26.183 19.6133 25.1281 21.8333 23.3825C18.8125 21.0184 16.8509 17.2732 16.8509 13.0915Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 13.0915C43 20.3278 37.1448 26.183 29.9085 26.183C26.8538 26.183 24.0533 25.1281 21.8333 23.3825C24.8879 20.9803 26.8156 17.2732 26.8156 13.0915C26.8156 8.90985 24.8498 5.19847 21.8333 2.80048C24.0491 1.05495 26.8495 0 29.9042 0C37.1448 0 43 5.89329 43 13.0915Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.9a2e25ddd8d9fedd69d812667bcba854.svg";
export { ForwardRef as ReactComponent };